
import { supabase } from '@/integrations/supabase/client';

// Function to check if tables exist and have proper RLS policies
export const testDatabaseAccess = async () => {
  try {
    console.log('Testing database access...');
    
    // Check if we can access escort_profiles table
    const { data: profilesAccess, error: profilesError } = await supabase
      .from('escort_profiles')
      .select('id')
      .limit(1);
      
    if (profilesError) {
      console.error('Cannot access escort_profiles table:', profilesError);
      return { success: false, error: profilesError };
    }
    
    // Check if we can access escort_photos table
    const { data: photosAccess, error: photosError } = await supabase
      .from('escort_photos')
      .select('id')
      .limit(1);
      
    if (photosError) {
      console.error('Cannot access escort_photos table:', photosError);
      // Don't fail completely, as we might still have access to profiles
    }
    
    // Check if we can access escort_services table
    const { data: servicesAccess, error: servicesError } = await supabase
      .from('escort_services')
      .select('id')
      .limit(1);
      
    if (servicesError) {
      console.error('Cannot access escort_services table:', servicesError);
      // Don't fail completely, as we might still have access to profiles
    }
    
    // Check if we can access escort_rates table
    const { data: ratesAccess, error: ratesError } = await supabase
      .from('escort_rates')
      .select('id')
      .limit(1);
      
    if (ratesError) {
      console.error('Cannot access escort_rates table:', ratesError);
      // Don't fail completely, as we might still have access to profiles
    }
    
    console.log('Database access test successful:', {
      profiles: profilesAccess?.length || 0,
      photos: photosAccess?.length || 0,
      services: servicesAccess?.length || 0,
      rates: ratesAccess?.length || 0
    });
    
    return { 
      success: true, 
      counts: {
        profiles: profilesAccess?.length || 0,
        photos: photosAccess?.length || 0,
        services: servicesAccess?.length || 0,
        rates: ratesAccess?.length || 0
      }
    };
  } catch (error) {
    console.error('Database access test failed:', error);
    return { success: false, error };
  }
};
